import React from 'react';
import useToken from '../hooks/useToken';
import useUser from '../hooks/useUser';
import { useState, useEffect } from 'react';
import { SERVER_API_URL } from '../config/Constants'
import ViewProject from './ViewProject';
import ProjectsList from '../components/ProjectsList';
import { BrowserRouter, Route, Switch, useRouteMatch, Link } from 'react-router-dom';
import ImageBackground from "../components/ImageBackground"
import Image from "../components/Image";
import ProfileHeader from "../components/ProfileHeader"
import { useHistory } from "react-router-dom";
import fetchClient from "../utils/http-common";
import strings from "../config/strings";
import Utils from '../utils/utils'
import { HEADER_HEIGHT } from '../config/Constants'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight, faArrowLeft } from '@fortawesome/free-solid-svg-icons'
import Loader from "react-loader-spinner";

import {
  ScrollView,
  View,
  TextInput,
  Text,
  TouchableOpacity,
  StyleSheet,
  Platform,
  Alert,
  FlatList,
  ActivityIndicator,
  Dimensions
} from 'react-native';
import { render } from '@testing-library/react';



export default function Game() {

  const [loading, setLoading] = useState(false)


  const selectedColor = "#2ba5f7"
  const selectedBg = "rgba(255,255,255,0.4)"

  const defaultColor = "#525252"
  const defaultBg = "rgba(255,255,255,0.4)"



  useEffect(() => {

    let mounted = true;


    return () => mounted = false;
  }, [])


  const renderLoading = () => {
    return (
      <View style={{width: "100%", justifyContent:"center", alignItems:"center", padding: 50}}>
        <Loader
          type="ThreeDots"
          color="#2ba5f7"
          height={100}
          width={100}
          // timeout={8000} //3 secs
        />
      </View>
    )
  }

  if (loading)
    return renderLoading()

  return(

        <View style={{flex: 1, flexDirection:'column', width: Dimensions.get('window').width, height: Dimensions.get('window').height}}>

        <iframe className="GameContainer" style={{flex: 1, flexDirection:'column', width: Dimensions.get('window').width, height: Dimensions.get('window').height}} src="/game/magical-yarn-story.html"></iframe>
        </View>
  );
}


const styles = StyleSheet.create({
  containerFullScreen: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    justifyContent: "center",
    alignItems: "center",
    flex: 0,
    elevation: 4,
    zIndex: 5000,
    backgroundColor:"rgba(0,0,0,0.9)",
    padding: 12
  },

});


